import 'owl.carousel';
import 'slick-carousel';
import 'chosen-js';





const scirpts = require.context('./', true, /\.(j|t)sx?$/);
scirpts.keys().forEach(scirpts);